/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EvaluationsReportControllerGetEvaluationResultsReport200ResponseDataResultsInner } from './evaluationsReportControllerGetEvaluationResultsReport200ResponseDataResultsInner';
import { EvaluationsReportControllerGetEvaluationResultsReport200ResponseDataRelationTypesInner } from './evaluationsReportControllerGetEvaluationResultsReport200ResponseDataRelationTypesInner';


export interface EvaluationsReportControllerGetEvaluationResultsReport200ResponseData { 
    results?: Array<EvaluationsReportControllerGetEvaluationResultsReport200ResponseDataResultsInner>;
    relationTypes?: Array<EvaluationsReportControllerGetEvaluationResultsReport200ResponseDataRelationTypesInner>;
    count?: number;
    totalReturned?: number;
}

